import { createAxiosInstance } from '~/plugins/axios.plugin';

class UploadService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API, useAccessToken: true });
    this.clientUpload = createAxiosInstance({ addDefaultHeaders: false });
  }

  getSignature({ folderName, useMediaBucket, fileExtension, contentType }) {
    return this.client.get(`/content/upload`, {
      params: {
        contentType,
        folderName,
        mediaBucket: useMediaBucket,
        fileExtension
      }
    });
  }

  uploadFile(url, file) {
    return this.clientUpload.put(url, file, {
      headers: { 'Content-Type': file.type }
    });
  }
};

export default new UploadService();
